<template>
  <div
    class="bg-white rounded-md overflow-hidden shadow hidden md:block mt-4"
    v-if="featureImage"
  >
    <img class="w-full" :src="featureImage" id="topimg" />
  </div>
</template>
<script>
export default {
  name: 'FeatureImage',
  props: ['featureImage'],
};
</script>